import angular from 'angular';
import ComponentsModule from './components/components';

const DataModule = angular.module('control-room.commons.data', [ComponentsModule.name]);

export default DataModule;
